export enum MessageType {
    Authenticated= 'authenticated',
    ProcessingOn = 'processingOn',
    ProcessingOff = 'processingOff',
    Logout = 'logout',
    CustomerCreated = 'customerCreated',
    ConfigurationCreated = 'configurationCreated',
    ParameterCreated = 'parameterCreated',
    UserSQSaved = 'userSQSaved',
    FactorResetted = 'FactorReseted',
    AppCInitLoaded = 'appCInitLoaded',
    LoginRequired = 'loginRequired',
    UserDeleted = 'Delete',
    UserCreated = 'CREATED',
	    HideMenu='HideMenu',
	    MfaConfigurationChanged = 'mfaConfigurationChanged'
}

export enum AlertTypes {
  Success,
  Error,
  Warning,
  Clear,
  ClearError
}
